'use client';

import * as RadixAccordion from '@radix-ui/react-accordion';
import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';

import type { Footer } from '@/types';

import styles from './FooterLinksMobile.module.scss';

export default function FooterLinksMobile({ footerGlobal }: { footerGlobal: Footer }) {
    const [openedIndex, setOpenedIndex] = useState<string | undefined>(undefined);

    if (!footerGlobal.rows) return <></>;

    return (
        <div className={styles.container}>
            <nav aria-label="Footer navigation" className={styles.links}>
                <RadixAccordion.Root type="single" value={String(openedIndex)}>
                    {footerGlobal.rows.map((row) => (
                        <RadixAccordion.Item
                            value={row.id ?? ''}
                            className={classNames(styles.container)}
                            key={row.id}
                        >
                            <RadixAccordion.Trigger
                                className={styles.button}
                                onClick={() => {
                                    if (openedIndex !== row.id) {
                                        setOpenedIndex(row.id ?? '');
                                    } else if (openedIndex === row.id) {
                                        setOpenedIndex(undefined);
                                    }
                                }}
                            >
                                <span>{row.name}</span>
                                <ChevronDown
                                    className={classNames(styles.arrow, {
                                        [styles.open]: openedIndex === row.id,
                                    })}
                                />
                            </RadixAccordion.Trigger>

                            <RadixAccordion.Content className={styles.bodyWrapper}>
                                <div className={styles.body} id={row.id ?? ''}>
                                    {row.items &&
                                        row.items.map((item) => {
                                            const href = item.link.reference
                                                ? item.link.reference.path
                                                : item.link.url;

                                            const title =
                                                item.link.reference && 'meta' in item.link.reference
                                                    ? item.link.reference.meta?.title
                                                    : item.link.label;

                                            return (
                                                <Link
                                                    key={item.id}
                                                    href={href ?? ''}
                                                    title={title}
                                                    className={styles.link}
                                                >
                                                    {item.link.label}
                                                </Link>
                                            );
                                        })}
                                </div>
                            </RadixAccordion.Content>
                        </RadixAccordion.Item>
                    ))}
                </RadixAccordion.Root>
            </nav>
        </div>
    );
}
